import { StateCreator } from "zustand";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { FetchMapLocationType } from "../../../domain/models/brick-management-report/brick-management-data";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchMapLocation } from "../../../domain/useages/brick-management/fetch-map-location";
import Endpoints from "../../../domain/endpoints";
import { RemoteFetchMapLocation } from "../../../data/usecases/brick-management/remote-fetch-map-location";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMapLocationInterface {
  FetchMapLocation: FetchMapLocationType;
  FetchMapLocationState: FetchState;
  fetchMapLocation: Function;
}

const initialStates = {
  FetchMapLocation: {} as FetchMapLocationType,
  FetchMapLocationState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMapLocationSlice: StateCreator<
  FetchMapLocationInterface
> = (set) => ({
  ...initialStates,
  fetchMapLocation: async (params: FetchMapLocation.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMapLocation = new RemoteFetchMapLocation(
      `${BASE_URL}${Endpoints.FETCH_MAP_LOCATION}`,
      axiosHttpClient
    );

    set(() => ({ FetchMapLocationState: FetchState.LOADING }));
    let result = await remoteFetchMapLocation.fetch(params);
    set(() => ({
      FetchMapLocation: result,
      FetchMapLocationState: FetchState.SUCCESS,
    }));
    return result;
  },
});
